import React, { useState } from 'react';
import { doc, setDoc } from "firebase/firestore";
import { db } from '../firebase';// adjust path to your firebase.js
import { useAuth } from "../AuthContext"; // if you're using a custom auth context


const SkillBadge = ({ skill }) => {
  const [isBroken, setIsBroken] = useState(false);

  const skillMap = {
    'c++': 'cplusplus',
    'c#': 'csharp',
    'f#': 'fsharp',
    'node.js': 'nodejs',
  };

  const raw = skill.toLowerCase().trim();
  const normalized = skillMap[raw] || raw.replace(/\+/g, 'plus').replace(/\s/g, '');
  const iconUrl = `https://skillicons.dev/icons?i=${normalized}`;

    // Always fallback to text for certain known issues
  const alwaysFallback = ['cplusplus', 'csharp', 'fsharp'];

  return (
    <div className="d-flex align-items-center me-3 mb-2">
      {(!isBroken && !alwaysFallback.includes(normalized)) ? (
        <img
          src={iconUrl}
          alt={skill}
          style={{ height: '24px', marginRight: '6px' }}
          onError={() => setIsBroken(true)}
        />
      ) : (
        <span style={{ marginRight: '6px', color: '#fff' }}>{skill}</span>
      )}
    </div>
  );
};




const PortfolioPreview = ({ data }) => {
  const { user } = useAuth();
  console.log('Skills received:', data.skills);
  return (
   <div
   id="portfolio-preview"
  className="p-4 rounded portfolio-preview"
  style={{
    backgroundColor: data.themeColor || '#1a1a2e',
    maxWidth: '100%',
    overflowX: 'hidden',
  }}
>
  {/* Profile + Name */}
  <div className="d-flex align-items-center mb-3">
    {data.profileImage && (
    <img
    src={data.profileImage}
    alt="Profile"
    className="mb-3"
    style={{
      width: 140,
      height: 140,
      objectFit: 'cover',
      borderRadius: '50%',
      border: `3px solid ${data.imageBorderColor}`,
      boxShadow: `0 0 20px ${data.imageBorderColor}99`,
      marginRight: '1.5rem' // 99 = 60% opacity
    }}
      />
    )}
    <h3 className="m-0 text-white">{data.name || 'Your Name'}</h3>
  </div>

  <p className="text-muted"><em>{data.bio}</em></p>

<h5>Skills :</h5>
<div className="mb-3 d-flex flex-wrap">
  {data.skills.map((skill, i) => (
  <SkillBadge key={i} skill={skill} />
))}

</div>

  <h5 className="text-white">Projects:</h5>
{data.projects.map((proj, i) => (
  <div key={i} className="mb-3 d-flex align-items-start">
    <div
  className="project-badge me-2"
  style={{
    backgroundColor: proj.color || '#ff007f',
    boxShadow: `0 0 6px ${proj.color || '#ff007f'}`
  }}
></div>

    <div>
      <strong className="project-title">{proj.title}</strong>
      <p className="project-description">{proj.description}</p>
      {proj.link && (
        <a
          href={proj.link}
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-sm btn-outline-info"
        >
          View Project
        </a>
      )}
    </div>
  </div>
))}


  <p className="mt-4 text-white"><strong>Contact:</strong> {data.contact}</p>

  <button
  className="btn btn-outline-info mt-3"
  onClick={async () => {
    if (!user) {
      alert("You must be logged in to share your portfolio.");
      return;
    }

    try {
      await setDoc(doc(db, "portfolios", user.uid), {
        ...data,
        timestamp: Date.now(),
      });

      const shareUrl = `${window.location.origin}/view?id=${user.uid}`;
      navigator.clipboard.writeText(shareUrl);
      alert("Portfolio link copied to clipboard:\n" + shareUrl);
    } catch (error) {
      console.error("Error saving portfolio:", error);
      alert("Failed to save portfolio. Try again.");
    }
  }}
>
  Share My Portfolio
</button>


</div>

  );
};

export default PortfolioPreview;
